import type { ReactNode } from 'react'
import { Icon } from '@/ds'
import type { IconName } from '@/ds'
import { cx } from '@/ds'
import { useAppNavigate, withQuery } from '@/lib/query-params'
import type { QueryChanges } from '@/lib/query-params'
import './LinkRow.css'

export interface LinkRowProps {
  icon: IconName
  title: ReactNode
  subtitle?: ReactNode
  /** Ruta interna (conserva la query) o `href` externo */
  to?: string
  href?: string
  /** Datos para la pantalla destino (history.state) */
  state?: unknown
  /** Cambios en la query de la ruta interna (p. ej. `{ volver: 'extras' }`) */
  query?: QueryChanges
  /** Cifras tabulares en el subtítulo (importes, fechas) */
  tabular?: boolean
  className?: string
}

/** Fila de tarjeta con icono, título, subtítulo y chevron (bundle B1: "Cómo llegar", "Guía de la casa", "Cargos", "Factura"). */
export function LinkRow({ icon, title, subtitle, to, href, state, query, tabular, className }: LinkRowProps) {
  const { search, go } = useAppNavigate()
  const inner = (
    <>
      <Icon name={icon} size={24} className="hp-linkrow__icon" />
      <span className="hp-linkrow__text">
        <span className="hp-linkrow__title">{title}</span>
        {subtitle && <span className={cx('hp-linkrow__subtitle', tabular && 'tnum')}>{subtitle}</span>}
      </span>
      <Icon name="chevron-right" size={22} className="hp-linkrow__chevron" />
    </>
  )
  if (to) {
    return (
      <a
        href={withQuery(to, search, query)}
        onClick={(e) => {
          e.preventDefault()
          go(to, { state, ...(query ? { query } : {}) })
        }}
        className={cx('hp-linkrow', className)}
      >
        {inner}
      </a>
    )
  }
  return (
    <a href={href} target="_blank" rel="noreferrer" className={cx('hp-linkrow', className)}>
      {inner}
    </a>
  )
}
